import { render, staticRenderFns } from "./NewQCStep1.vue?vue&type=template&id=65c356ea&scoped=true&"
import script from "./NewQCStep1.vue?vue&type=script&lang=js&"
export * from "./NewQCStep1.vue?vue&type=script&lang=js&"
import style0 from "./NewQCStep1.vue?vue&type=style&index=0&id=65c356ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c356ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VCheckbox,
  VForm,
  VTextField,
})
